// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"15e58f32","549":"15e58f32"}[chunkId] + ".chunk.css";
};